import { render, staticRenderFns } from "./Avatar.vue?vue&type=template&id=5db2a559&scoped=true"
import script from "./Avatar.vue?vue&type=script&lang=ts"
export * from "./Avatar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db2a559",
  null
  
)

export default component.exports